export const DATETIME_DISPLAY_FORMAT = 'yyyy-MM-dd HH:mm';
